<script lang="ts">
  import '../../../../app.postcss'
  import contactScrollerImg from '$lib/assets/branding/logo_vector.svg'
  import { deferVideo } from '$lib/attachments/deferVideo'

  const contactScroller = [
    {
      img: contactScrollerImg,
      description: 'admin@butane.dev',
    },
    {
      img: contactScrollerImg,
      description: 'admin@butane.dev',
    },
    {
      img: contactScrollerImg,
      description: 'admin@butane.dev',
    },
  ]
  const scrollingContactItems = [...contactScroller, ...contactScroller]
</script>

<div class="mx-auto">
  <section class="relative flex flex-col items-center overflow-x-clip text-center">
    <div class="mt-16 h-[220px] xl-mobile:h-[250px] lg:mt-24 lg:h-[300px]" style="pointer-events: none;">
      <video
        {@attach deferVideo()}
        autoplay
        class="clipped-image fixed-size-video mt-16"
        playsinline
        loop
        muted
        defaultMuted
        disableremoteplayback
        oncontextmenu={(event) => event.preventDefault()}
        preload="none"
      >
        <source data-src="https://assets.butane.dev/circle-tail.webm" type="video/webm" />
        <source data-src="https://assets.butane.dev/circle-tail.mp4" type="video/mp4" />
      </video>
    </div>

    <div class="text-container z-[1] flex flex-col items-center">
      <h1 class="scale-x w-[50vw] font-cirka text-[12vw] leading-[100%]">How can we help?</h1>
      <p class="w-[243px] py-4 font-graphik text-[18px] leading-[23.4px]">
        If you have a question about our protocol or just want to connect with our awesome community, this is the place
        for you.
      </p>
    </div>

    <div class="banner-container z-[2] max-w-[100vw] rotate-[-6deg] self-center whitespace-nowrap">
      <ul
        class="scroller flex w-max flex-wrap items-baseline gap-x-4 bg-flame py-1 font-graphik text-[44px] font-normal text-black motion-safe:animate-contact-infinite-scroll"
      >
        {#each scrollingContactItems as { img, description }, index}
          <li class="flex items-center" aria-hidden={index >= contactScroller.length}>
            <div class="mr-1 rounded-full bg-black p-2">
              <img src={img} alt="butane logo vector" class="h-[30px] w-[30px]" />
            </div>
            <p>{description}</p>
          </li>
        {/each}
      </ul>
    </div>
  </section>
</div>

<style lang="postcss">
  .banner-container {
    margin-top: 4rem;
  }

  .clipped-image {
    clip-path: inset(0 0 50% 0%);
  }

  .fixed-size-video {
    max-height: 610px;
    height: 610px;
    object-fit: cover;
  }

  @media (min-width: 500px) {
    h1 {
      font-size: 60px;
      width: 250px;
    }
    .clipped-image {
      clip-path: polygon(0 0, 100% 0, 100% 72%, 0 88%);
    }
    .fixed-size-video {
      height: 595px;
      max-height: 595px;
    }
  }

  @media (min-width: 1024px) {
    .banner-container {
      margin-top: 9rem;
    }

    h1 {
      font-size: 80px;
      width: 300px;
      line-height: 80px;
    }
    p {
      width: 400px;
    }

    .fixed-size-video {
      max-height: 650px;
      height: 650px;
    }

    .clipped-image {
      clip-path: polygon(0 0, 100% 0, 100% 69%, 0 84%);
    }
  }

  @media (min-width: 1440px) {
    .fixed-size-video {
      max-height: 900px;
      height: 900px;
    }

    h1 {
      font-size: 110px;
      width: 400px;
      line-height: 100px;
    }

    .text-container p {
      width: 412px;
      font-size: 20px;
      line-height: 26px;
    }

    ul {
      display: flex;
      align-items: center;
      column-gap: 35rem;
      padding: 1.2rem 0;
    }

    li p {
      font-size: 104px;
      line-height: 83px;
    }

    li img {
      height: 90px;
      width: 90px;
      scale: 0.8;
    }
  }

  @media (min-width: 1440px) and (prefers-reduced-motion: no-preference) {
    .scroller {
      @apply animate-contact-infinite-scroll-lg-desktop;
    }
  }
</style>
